import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useTheme } from '../../ThemeContext';

import { Wrapper, Content, Icon, Text } from './NoResults.style';

const NoResults = ({ label, fullmode = false }) => {
  const intl = useIntl();
  const theme = useTheme();
  return (
    <Wrapper theme={theme.noResults} fullmode={fullmode ? true : undefined}>
      <Content>
        <Icon className='material-icons'>block</Icon>
        <Text>
          {label ? label : intl.formatMessage({ id: 'NO_RESULTS.NO_RESULTS' })}
        </Text>
      </Content>
    </Wrapper>
  );
};

NoResults.propTypes = {
  label: PropTypes.string,
  fullmode: PropTypes.bool,
};

export default NoResults;
